import { DeviceType } from "@intelligems/ig-types";

export const deviceTypeList: { label: string; key: DeviceType }[] = [
  {
    label: "All Devices",
    key: "any",
  },
  {
    label: "Desktop",
    key: "desktop",
  },
  {
    label: "Mobile",
    key: "mobile",
  },
];
